// extracted by mini-css-extract-plugin
export default {"titleContainer":"post-list-view__titleContainer__Agqsm","contentContainer":"post-list-view__contentContainer__IArW5","sidenav":"post-list-view__sidenav__np9UP"};